 <avi-dynamic-data-grid
    *ngIf="logsSignpostStore.logsDefaultSignpostData$ | async as logsSignpostData"
    [config]="logListGridConfig"
    [rows]="logsSignpostData"
    [rowsTotal]="logsSignpostData.length"
    [isLoading]="logsSignpostStore.isLoading$ | async"
></avi-dynamic-data-grid>
<div
    class="logs-signpost-default-view-log-list__loader clr-wrapper"
    *ngIf="logsSignpostStore.isLoading$ | async"
>
    <clr-spinner [clrMedium]="true"></clr-spinner>
</div>

<ng-template
    #nameFieldTemplateRef
    let-row
    let-index="index"
>
    <div
        *ngIf="logsSignpostStore.logSelectedSignpostConfigKey$ | async as configKey"
        class="logs-signpost-default-view-log-list__content"
    >
        <span
            *ngIf="row.value.isValid"
            logFilter
            [property]="row.value.param"
            [value]="row.value.value"
            (onFilterAdd)="logsSignpostStore.closeSignpost()"
            aviTitle="{{ row.value.value | signpostLogDataTransform: configKey }}"
        >
            {{ row.value.value | signpostLogDataTransform: configKey }}
        </span>
        <ng-container
            *ngIf="!row.value.isValid"
            [ngTemplateOutlet]="noData"
            [ngTemplateOutletContext]="{ $implicit: row.value.param }"
        ></ng-container>
    </div>
</ng-template>

<ng-template
    #rangeFieldTemplateRef
    let-row
    let-index="index"
>
    <div
        *ngIf="logsSignpostStore.logSelectedSignpostConfigKey$ | async as configKey"
        class="logs-signpost-default-view-log-list__content"
    >
        <span
            *ngIf="row.value.isValid"
            logFilterRange
            [property]="row.value.param"
            [start]="row.value.value.start"
            [end]="row.value.value.end"
            (onFilterAdd)="logsSignpostStore.closeSignpost()"
        >
            {{ row.value.value | signpostLogDataTransform: configKey }}
        </span>
        <ng-container
            *ngIf="!row.value.isValid"
            [ngTemplateOutlet]="noData"
            [ngTemplateOutletContext]="{ $implicit: row.value.param }"
        ></ng-container>
    </div>
</ng-template>

<ng-template
    #progressBarFieldTemplateRef
    let-row
    let-index="index"
>
    <avi-progress-bar
        [percentage]="row.percentage"
        [hidePercentage]="true"
    ></avi-progress-bar>
</ng-template>

<ng-template
    #noData
    let-property
>
    <span
        logFilterableEmptyField
        [property]="property"
        (onFilterAdd)="logsSignpostStore.closeSignpost()"
    ></span>
</ng-template>
